
  

  (function () {
  'use strict';

  /* ================================
     CONFETTI + TOAST STATE + HELPERS
     ================================ */

  var offerProgressState = {
    shirt:   { initialized: false, lastQty: 0 }, // shirt VALUE for confetti/toast
    trouser: { initialized: false, lastQty: 0 }  // trouser QTY for confetti/toast
  };

  function getOfferKey(barId) {
    if (barId === 'shirt-bar') return 'shirt';
    if (barId === 'trouser-bar') return 'trouser';
    return null;
  }

  // Ensure toast CSS exists (inserts a <style> once)
  function ensureToastStyles() {
    if (document.getElementById('cart-offer-toast-style')) return;

    var style = document.createElement('style');
    style.id = 'cart-offer-toast-style';
    style.textContent = ''
      + '.cart-offer-toast{'
      + ' position:absolute;'
      + ' left:50%;'
      + ' bottom:16px;'
      + ' transform:translateX(-50%) translateY(20px);'
      + ' background:#991B32;'
      + ' color:#ffffff;'
      + ' padding:8px 14px;'
      + ' border-radius:999px;'
      + ' font-size:13px;'
      + ' line-height:1.3;'
      + ' box-shadow:0 4px 12px rgba(0,0,0,0.18);'
      + ' opacity:0;'
      + ' z-index:10;'
      + ' max-width:500px%;'      // 🔹 new
      + ' text-align:center;'  // 🔹 optional
      + ' animation:cartOfferToastIn 0.35s ease-out forwards;'
      + '}'
      + '@keyframes cartOfferToastIn{'
      + ' from{opacity:0;transform:translateX(-50%) translateY(20px);}'
      + ' to{opacity:1;transform:translateX(-50%) translateY(0);}'
      + '}'
      + '.cart-offer-toast--hide{'
      + ' animation:cartOfferToastOut 0.25s ease-in forwards;'
      + '}'
      + '@keyframes cartOfferToastOut{'
      + ' from{opacity:1;transform:translateX(-50%) translateY(0);}'
      + ' to{opacity:0;transform:translateX(-50%) translateY(20px);}'
      + '}';

    document.head.appendChild(style);
  }



  // Build toast message based on which milestone was crossed
//function getToastMessage(key, step) {
  //if (key === 'shirt') {
    //if (step >= 4) return '🥳 Big win! <b>45% OFF</b> unlocked!';
    //if (step >= 3) return '🥳 Nice one! <b>35% OFF</b> applied!';
    //if (step >= 2) return '🥳 Awesome! <b>25% OFF</b> activated!';
  //} else if (key === 'trouser') {
    //if (step >= 3)  return '🛍️ Buy 2 Get <b>1 FREE</b> on trousers unlocked!';
    //if (step >= 2)  return '✨ <b>50% OFF</b> on 2nd trouser unlocked!';
  //}
  //return '';
//}


  // Show toast inside Cart Drawer
  function showOfferToast(key, step) {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    var msg = getToastMessage(key, step);
    if (!msg) return;

    ensureToastStyles();

    // Remove old toast if still visible
    var existing = drawer.querySelector('.cart-offer-toast');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }

    var toast = document.createElement('div');
    toast.className = 'cart-offer-toast';
    toast.innerHTML = msg;

    // Ensure drawer can position absolutely
    var cs = window.getComputedStyle(drawer);
    if (cs.position === 'static') {
      drawer.style.position = 'relative';
    }

    drawer.appendChild(toast);

    // Auto-hide after ~5s
    setTimeout(function () {
      if (!toast || !toast.parentNode) return;
      toast.classList.add('cart-offer-toast--hide');
    }, 4500);

    setTimeout(function () {
      if (!toast || !toast.parentNode) return;
      toast.parentNode.removeChild(toast);
    }, 5000);
  }

  // Confetti inside Cart Drawer only
  function fireDrawerConfetti() {
    if (typeof confetti !== 'function') {
      console.warn('[cart-offer] confetti library not found');
      return;
    }

    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) {
      console.warn('[cart-offer] #Cart-Drawer not found');
      return;
    }

    var cs = window.getComputedStyle(drawer);
    if (cs.position === 'static') {
      drawer.style.position = 'relative';
    }

    var canvas = drawer.querySelector('canvas.cart-drawer-confetti');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'cart-drawer-confetti';
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.right = '0';
      canvas.style.bottom = '0';
      canvas.style.left = '0';
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = '5';
      drawer.appendChild(canvas);
    }

    var instance = confetti.create(canvas, {
      resize: true,
      useWorker: true
    });

    instance({
      particleCount: 120,
      spread: 70,
      startVelocity: 35,
      origin: { x: 0.5, y: 0.3 }
    });

    console.log('[cart-offer] Confetti fired inside cart drawer');
  }

  function triggerConfettiForMilestones(qty, steps, barId) {
  var key = getOfferKey(barId);
  if (!key || !offerProgressState[key]) return;

  var state = offerProgressState[key];

  // Use lastQty if we have it, otherwise treat as 0 on very first run
  var prevQty = (typeof state.lastQty === 'number') ? state.lastQty : 0;

  // Mark that we've initialized this bar at least once
  if (!state.initialized) {
    state.initialized = true;
  }

  var crossed = false;
  var highestCrossedStep = null;

  // Find ALL crossed steps in this update, keep only the highest one
  for (var i = 0; i < steps.length; i++) {
    var step = steps[i];
    if (prevQty < step && qty >= step) {
      crossed = true;
      highestCrossedStep = step; // keep updating so we end with biggest
    }
  }

  // Update last seen qty
  state.lastQty = qty;

  if (crossed && highestCrossedStep != null) {
    fireDrawerConfetti();
    showOfferToast(key, highestCrossedStep);
  }
}

/* ================================
     VALUE → PERCENT HELPERS
     ================================ */

  function computeLinearPercent(value, steps) {
    if (!steps.length) return 0;
    var maxStep = steps[steps.length - 1];
    if (maxStep <= 0) return 0;
    if (value <= 0) return 0;
    if (value >= maxStep) return 100;
    return (value / maxStep) * 100;
  }

  function computeWeightedPercent(value, steps, percentStops) {
    var n = steps.length;
    if (!n || !percentStops || percentStops.length !== n) {
      return computeLinearPercent(value, steps);
    }

    if (value <= 0) return 0;

    var maxStep = steps[n - 1];
    if (value >= maxStep) return percentStops[n - 1];

    if (value < steps[0]) {
      return (value / steps[0]) * percentStops[0];
    }

    for (var i = 1; i < n; i++) {
      if (value < steps[i]) {
        var startStep = steps[i - 1];
        var endStep   = steps[i];
        var range = endStep - startStep;
        if (range <= 0) return percentStops[i - 1];

        var t = (value - startStep) / range; // 0..1

        var startPct = percentStops[i - 1];
        var endPct   = percentStops[i];
        return startPct + t * (endPct - startPct);
      }
    }

    return percentStops[n - 1];
  }


  /* ================================
     READ DATA FROM DOM
     ================================ */

  function readOfferData() {
    var box = document.getElementById('offer-data');
    if (!box) {
      return { shirtQty: 0, trouserQty: 0, shirtValue: 0 };
    }

    var shirtQty   = parseInt(box.getAttribute('data-shirt') || '0', 10);
    var trouserQty = parseInt(box.getAttribute('data-trouser') || '0', 10);
    var shirtTotal = parseInt(box.getAttribute('data-shirt-total') || '0', 10);

    if (isNaN(shirtQty))   shirtQty = 0;
    if (isNaN(trouserQty)) trouserQty = 0;
    if (isNaN(shirtTotal)) shirtTotal = 0;

    return {
      shirtQty:   shirtQty,
      trouserQty: trouserQty,
      shirtValue: shirtTotal
    };
  }

  /* ================================
     MAIN VISUAL UPDATE
     ================================ */

  function updateProgressVisual(
    qty,
    steps,
    barId,
    textId,
    iconIds,
    labels,
    freeItemsArray
  ) {
    var bar  = document.getElementById(barId);
    var text = document.getElementById(textId);
    if (!bar || !text || !steps.length) return;

    // Reset icons
    var icons = [];
    for (var i = 0; i < iconIds.length; i++) {
      var icon = document.getElementById(iconIds[i]);
      if (icon) {
        icon.classList.remove('active', 'pulse');
        icons.push(icon);
      }
    }
  
    var totalStages = steps.length;
    var maxStep = steps[totalStages - 1];

    // Find last reached milestone
    var currentIndex = -1;
    for (var j = 0; j < totalStages; j++) {
      if (qty >= steps[j]) currentIndex = j;
    }
    var nextIndex = currentIndex + 1;

    // --------- Message text ---------
    var message = '';
    if (qty >= maxStep) {
      if (freeItemsArray && freeItemsArray.length) {
        var freeCount = freeItemsArray[freeItemsArray.length - 1];
        message = '🎉 You unlocked Buy 2 Get <b>' + freeCount + ' FREE</b>!';
      } else {
        message = '🎉 You unlocked <b>' + labels[labels.length - 1] + '</b>';
      }
    } else if (currentIndex >= 0) {
      var remaining = steps[nextIndex] - qty;
      var labelNext = labels[nextIndex] || labels[labels.length - 1] || '';

      if (freeItemsArray && freeItemsArray.length) {
        var labelNow = labels[currentIndex] || '';
        message =
          '🎉 You unlocked.. <b>' + labelNow +
          '</b><br>Add <b>' + remaining +
          '</b> more to unlock <b>' + labelNext + '</b>';
      } else {
        message =
         'Add <b>' + remaining + '</b> more Item to get <b>' + labelNext + '</b>';
      }
    } else {
      var remainingFirst = steps[0] - qty;
      message =
      'Add <b>' + remainingFirst + '</b> more Item to get <b>' + (labels[0] || '') + '</b>';
      
    }

    text.innerHTML = message;

    // --------- Icons state ---------
    if (currentIndex >= 0) {
      for (var k = 0; k <= currentIndex && k < icons.length; k++) {
        icons[k].classList.add('active');
      }
    }
    if (nextIndex < icons.length && qty < maxStep) {
      icons[nextIndex].classList.add('pulse');
    }

    // --------- Bar fill (no reload / no refill from 0) ---------
    var pct;
    if (barId === 'shirt-bar') {
      pct = computeWeightedPercent(qty, steps, [35, 75, 100]);
    } else {
      pct = computeLinearPercent(qty, steps);
    }

    if (pct > 100) pct = 100;
    if (pct < 0)   pct = 0;

    bar.style.transition = 'none';
    bar.style.width = pct.toFixed(2) + '%';

    // --------- CONFETTI + TOAST HOOK ---------
    triggerConfettiForMilestones(qty, steps, barId);
  }

  function updateAllOffers() {
    var data = readOfferData();
    var shirtQty = data.shirtQty || 0;
    var shirtValue = data.shirtValue || 0;
    var trouserQty = data.trouserQty || 0;

    // 🧥 SHIRT OFFER – VALUE BASED
    updateProgressVisual(
      shirtQty,
      [2, 3, 4],
      'shirt-bar',
      'shirt-text',
      ['shirt-step-1', 'shirt-step-2', 'shirt-step-3'],
      ['25% OFF', '35% OFF', '45% OFF']
    );

    // 👖 TROUSER OFFER – QTY BASED
    updateProgressVisual(
      trouserQty,
      [2, 2, 3],
      'trouser-bar',
      'trouser-text',
      ['trouser-step-1', 'trouser-step-2', 'trouser-step-3'],
      ['unlock 50% OFF 2nd Item', 'unlock 50% OFF 2nd Item', 'get a FREE item!'],
      [1, 2, 3]
    );
  }


  function safeUpdateAllOffers() {
    try {
      updateAllOffers();
    } catch (e) {
      console.error('cart-offer error:', e);
    }
  }

  /* ================================
     OBSERVERS – NO setInterval
     ================================ */

  var offerDataObserver = null;
  var drawerObserver = null;

  function attachOfferDataObserver() {
    if (offerDataObserver) {
      offerDataObserver.disconnect();
      offerDataObserver = null;
    }

    var box = document.getElementById('offer-data');
    if (!box || typeof MutationObserver === 'undefined') return;

    offerDataObserver = new MutationObserver(function (mutations) {
      var shouldUpdate = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (
          m.type === 'attributes' &&
          (m.attributeName === 'data-shirt' ||
           m.attributeName === 'data-trouser' ||
           m.attributeName === 'data-shirt-total')
        ) {
          shouldUpdate = true;
          break;
        }
      }
      if (shouldUpdate) {
        safeUpdateAllOffers();
      }
    });

    offerDataObserver.observe(box, {
      attributes: true,
      attributeFilter: ['data-shirt', 'data-trouser', 'data-shirt-total']
    });
  }

  function attachDrawerObserver() {
    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }

    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    drawerObserver = new MutationObserver(function (mutations) {
      var foundOfferData = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.id === 'offer-data' ||
              (node.querySelector && node.querySelector('#offer-data'))) {
            foundOfferData = true;
            break;
          }
        }
        if (foundOfferData) break;
      }
      if (foundOfferData) {
        attachOfferDataObserver();
        safeUpdateAllOffers();
      }
    });

    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  function initCartOffers() {
    safeUpdateAllOffers();
    attachOfferDataObserver();
    attachDrawerObserver();

    document.addEventListener('shopify:section:load', function (evt) {
      try {
        if (
          evt &&
          evt.detail &&
          evt.detail.sectionId &&
          ('' + evt.detail.sectionId).indexOf('cart-drawer') !== -1
        ) {
          safeUpdateAllOffers();
          attachOfferDataObserver();
        }
      } catch (e) {
        console.warn('cart-offer shopify:section:load handler error', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartOffers);
  } else {
    initCartOffers();
  }
})();



/* ================================
     Extra button BG color change
     ================================ */
     
(function () {
  'use strict';

  var ICON_IDS = ['shirt-step-1', 'shirt-step-2', 'shirt-step-3'];
  var iconObservers = [];

  function clearObservers() {
    iconObservers.forEach(function (obs) {
      try { obs.disconnect(); } catch (e) {}
    });
    iconObservers = [];
  }

  function syncButtonsWithIcons() {
    var buttons = document.querySelectorAll('.offer-btn[data-sync]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var id = btn.getAttribute('data-sync');
      var icon = document.getElementById(id);

      if (!icon) continue;

      if (icon.classList.contains('active')) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    }
  }

  function attachIconObservers() {
    clearObservers();

    for (var i = 0; i < ICON_IDS.length; i++) {
      var icon = document.getElementById(ICON_IDS[i]);
      if (!icon) continue;

      var obs = new MutationObserver(syncButtonsWithIcons);
      obs.observe(icon, {
        attributes: true,
        attributeFilter: ['class']
      });

      iconObservers.push(obs);
    }

    syncButtonsWithIcons();
  }

  function watchCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    var drawerObserver = new MutationObserver(function () {
      attachIconObservers();
    });

    drawerObserver.observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  // Shopify section reload support
  document.addEventListener('shopify:section:load', function (e) {
    if (
      e &&
      e.detail &&
      e.detail.sectionId &&
      ('' + e.detail.sectionId).indexOf('cart') !== -1
    ) {
      setTimeout(attachIconObservers, 50);
    }
  });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachIconObservers();
      watchCartDrawer();
    });
  } else {
    attachIconObservers();
    watchCartDrawer();
  }
})();

